export default {
  getBatchesOfInstitute: "/setup/batch/getBatchesByLmsInstituteId"
};
